<template lang="pug">
	div.container-fluid
		.row
			.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
				.card
					.card-header.bg-info.text-white
						.row
							.col.text-left
								span.fa.fa-podcast.mr-2
								| Emisoras
							.col.text-right
								button.btn.btn-sm.btn-warning(@click="nuevaEmisora")
									span.fa.fa-plus.mr-2
									| Nueva
					table.table.table-striped.m-0
						tbody
							tr(:class="(emisora.activa) ? '' : 'text-danger'", v-for="emisora in listadoEmisoras", :key="emisora.ID_emisora", style="cursor:pointer;", @click="editarEmisora(emisora)")
								td(style="width:40px;text-align:center;")
									span.fa.fa-podcast
								td(style="text-align:left;") {{emisora.nombre}}
								td.text-right
									.badge.badge-danger(v-if="!emisora.activa") Inactiva
					.card-body.text-center(v-if="listadoEmisoras.length === 0")
						h3.text-danger
							span.fa.fa-info-circle
							br
							| No hay emisoras

			.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8
				.card(v-if="emisora")
					.card-header.bg-warning
						span.fa.fa-edit.mr-2
						| Editor de emisoras
					.card-body
						h3
							span.fa.fa-info-circle.mr-2
							| Información de identificación
						.row
							.col-xs-12.col-sm-12.col-md-12.col-lg-4.col-xl-4.text-center(@mouseover="verBtnLogotipo = true", @mouseout="verBtnLogotipo = false")
								img(v-if="!emisora.logotipo", src="./minus.svg", style="width:110px;height:110px;margin: 10px;opacity:0.5;")
								img(v-if="emisora.logotipo", :src="emisora.logotipo", style="width:100%;height:auto;margin: 10px;")
								br
								button.btn.btn-warning(v-if="emisora.ID_emisora", @click="subirLogotipo")
									span.fa.fa-upload.mr-2
									| Actualizar logotipo
							.col-xs-12.col-sm-12.col-md-12.col-lg-8.col-xl-8
								.row
									.col-xs-12.col-sm-12.col-md-12.col-lg-8.col-xl-8
										.form-group
											label Nombre de la emisora
											input.form-control(v-model="emisora.nombre")
									.col-xs-12.col-sm-12.col-md-12.col-lg-4.col-xl-4
										.form-group
											label ID XFrame
											input.form-control(v-model.number="emisora.xframe_ID")
								.form-group
									label Descripción
									textarea.form-control(v-model="emisora.descripcion", rows="4")
								.form-group
									label Estado
									br
									.btn-group
										button.btn(:class="(emisora.activa) ? 'btn-success' : ''", @click="emisora.activa = !emisora.activa") Activa
										button.btn(:class="(!emisora.activa) ? 'btn-danger' : ''", @click="emisora.activa = !emisora.activa") Inactiva
					.card-body.bg-light
						h3
							span.fa.fa-braille.mr-2
							| Parámetros de programación
						.row
							.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
								.card
									.card-header.bg-white
										b Buzones asociados
									.card-body
										.input-group
											.input-group-prepend
												.input-group-text
													span.fa.fa-search
											input-query(
												input-class="form-control",
												placeholder="Busca un buzón para asociarlo",
												:realtime="false",
												@selected="seleccionaBuzon"
												url="gestion-emisoras/php/api/emisoras/query-buzones.php"
											)
							.col-xs-12.col-sm-12.col-md-6.col-lg-6.col-xl-6
								.card
									.card-header.bg-white
										b Prioridad de colocación
					.card-footer
						button.btn.btn-primary(@click="guardarEmisora")
							span.fa.fa-save.mr-2
							| Guardar
				agregar-buzon(id-relleno="relleno.ID_relleno", id-buzon="relleno.BuzonID", nombre-buzon="relleno.nombre_buzon", v-if="relleno", @cerrar="relleno = null")

</template>

<script>
import AgregaBuzon from './agrega-buzon.vue'
import axios from 'axios'

export default {
	components: {
		'agregar-buzon': AgregaBuzon
	},
	data () {
		return {
			listadoEmisoras: [],
			emisora: null,
			verBtnLogotipo: false,
			relleno: null
		}
	},
	created () {
		this.getEmisoras()
	},
	methods: {
		getEmisoras () {
			axios.get('/gestion-emisoras/php/api/emisoras/buscar-emisoras.php')
				.then(res => {
					this.listadoEmisoras = res.data.listado
				})
				.catch(this.$responseError)
		},
		editarEmisora (emisora) {
			this.emisora = emisora
		},
		nuevaEmisora () {
			this.emisora = {
				ID_emisora: null,
				nombre: '',
				descripcion: '',
				activa: true
			}
		},
		subirLogotipo () {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.multiple = false
			inp.accept = '.png,.svg,.jpg'

			inp.onchange = () => {
				const form = new FormData()
				form.append('fichero', inp.files[0])
				axios.post('gestion-emisoras/php/api/emisoras/set-logo.php?ID_emisora=' + this.emisora.ID_emisora, form)
					.then(res => {
						this.emisora = res.data.emisora
						this.getEmisoras()
						document.body.removeChild(inp)
					})
					.catch(err => {
						document.body.removeChild(inp)
						this.$responseError(err)
					})
			}

			document.body.appendChild(inp)
			inp.click()
		},
		guardarEmisora () {
			axios.post('/gestion-emisoras/php/api/emisoras/set-emisora.php', this.emisora)
				.then(res => {
					// Se ha añadido la emisora
					this.getEmisoras()
					this.emisora = res.data.emisora
					this.$store.commit('toast/success', {
						titulo: 'Guardado',
						mensaje: 'Cambios guardados'
					})
				})
				.catch(this.$responseError)
		},

		seleccionaBuzon (e) {
			this.relleno = {
				ID_relleno: 'nuevo',
				nombre_buzon: e.datos.BuzonDescripcion,
				BuzonID: e.datos.BuzonID
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-emisoras/vue/componentes/emisoras/emisoras.vue